import { Helpers } from '../../helpers';
import { ICleanoutMethod } from '../../interfaces/icleanout-method';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ScenarioWell } from '../scenario-well';

export class CleanoutMethodBase {
  CleanoutMethodId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioWells_CleanoutMethod?: Array<ScenarioWell> | null;
  ProjectCompletionsParameters_CleanOutMethod?: Array<ProjectCompletionsParameter> | null;

  constructor(item?: ICleanoutMethod) {
    if (item) {

      this.CleanoutMethodId = item.CleanoutMethodId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioWells_CleanoutMethod = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_CleanoutMethod);
      this.ProjectCompletionsParameters_CleanOutMethod = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_CleanOutMethod);
    }
  }
}